import { render, staticRenderFns } from "./AtomIconBookOpen.vue?vue&type=template&id=718f594e&functional=true&"
import script from "./AtomIconBookOpen.vue?vue&type=script&lang=ts&"
export * from "./AtomIconBookOpen.vue?vue&type=script&lang=ts&"
import style0 from "./AtomIconBookOpen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
